import { Seniority, SeniorityDescription } from '../../enums/seniority';

export function getSeniorityDescription(seniority: Seniority): string {
  switch (seniority) {
    case Seniority.EntryLevel:
      return SeniorityDescription.EntryLevel;
    case Seniority.MidManagement:
      return SeniorityDescription.MidManagement;
    case Seniority.SeniorManagement:
      return SeniorityDescription.SeniorManagement;
    default:
      return 'Unknown';
  }
}
